import { Box, Grid, Typography } from '@mui/material'
import { format, parseISO } from 'date-fns'
import React from 'react'
import { AudienceOptions, CAMPAIGN_STATUS_VALUE_TO_LABEL } from '../../../reducers/campaign-edit/slice'
import { useStyles } from './style'
import SettingsBackupRestoreRoundedIcon from '@mui/icons-material/SettingsBackupRestoreRounded'

const CampaignItem = React.memo(({ campaign, index, onClick, onKeyPress }) => {
  const { status, isDefault } = campaign

  const classes = useStyles({ status })

  function DateColumn ({ date, label }) {
    if (!date) {
      return (
        <Typography className={classes.dateColumn} variant='body2' data-test={`${label}-${index}`} title='None'>
          None
        </Typography>
      )
    }

    return (
      <Typography className={classes.dateColumn} variant='body2' data-test={`${label}-${index}`} title={format(parseISO(date), 'PPpppp')}>
        {format(parseISO(date), 'dd/MM/yyyy')}
      </Typography>
    )
  }

  const audienceLabel = React.useMemo(() => {
    if (!campaign.audience) return ''
    return AudienceOptions.find(i => i.value === campaign.audience).label
  }, [campaign.audience])

  const statusLabel = React.useMemo(() => CAMPAIGN_STATUS_VALUE_TO_LABEL[campaign.status], [campaign.status])

  return (
    <Grid
      role='row button'
      data-test={`campaign-list-item-${index}`}
      container
      tabIndex={0}
      direction='row'
      alignItems='center'
      classes={{ root: classes.root }}
      onClick={() => onClick(campaign)}
      onKeyPress={(e) => onKeyPress(e, campaign)}
    >
      <Grid item md={4} className={classes.campaignColumn}>
        <Grid container alignItems='center' spacing={2}>
          <Grid item>
            <Typography variant='body2' data-test={`campaign-name-${index}`}>
              {campaign.name}
            </Typography>
            {isDefault && (
              <Typography variant='caption' className={classes.defaultText} data-test={`campaign-isdefault-${index}`}>
                <SettingsBackupRestoreRoundedIcon className={classes.defaultIcon} />
                <Box ml={2.5}><strong>Set as default</strong></Box>
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={2} data-test='audience'>
        <Typography variant='body2' data-test={`audience-${index}`}>
          {audienceLabel}
        </Typography>
      </Grid>
      <Grid item md={1} data-test='start-date'>
        <DateColumn date={campaign.startDate} label='start-date' />
      </Grid>
      <Grid item md={1} data-test='end-date'>
        <DateColumn date={campaign.endDate} label='end-date' />
      </Grid>
      <Grid item md={2} container alignItems='center' data-test='status'>
        <Grid item md={4}>
          <Typography className={classes.status} variant='body2' data-test={`status-${index}`}>
            {statusLabel}
          </Typography>
        </Grid>
      </Grid>
      <Grid item md={2} data-test='creation-date'>
        <Typography className={classes.dateColumn} variant='body2' data-test={`creation-date-${index}`} title={format(parseISO(campaign.createdAt), 'PPpppp')}>
          {format(parseISO(campaign.createdAt), 'dd/MM/yyyy')}
        </Typography>
      </Grid>
    </Grid>
  )
})

export default CampaignItem
